import { Theme, Components } from '@mui/material/styles';

export const BadgeOverrides: Components<Theme> = {
  MuiBadge: {
    defaultProps: {},
    styleOverrides: {
      root: () => ({
        color: '#ffffff',
      }),
      badge: {
        color: '#ffffff',
      },
    },
  },
};
